import { Component, OnInit, OnDestroy  } from '@angular/core';
import { FiltroModel } from '../../../shared/classes/FiltroModel';
import { ReportModel } from '../../../shared/classes/ReportModel';
import { ReportsService } from '../../../shared/services/reports.service';
import { ValidacaoDadosModel } from "../../../shared/classes/ValidacaoDadosModel";
import { RetornoConsultaModel } from "../../../shared/classes/RetornoConsultaModel";
import { Subject } from 'rxjs';
import { Adal4Service } from "adal-angular4";
import { Router, NavigationExtras, ActivatedRoute  } from "@angular/router";
import { GroupModel } from "../../../shared/classes/GroupModel";
import { GroupsService } from "../../../shared/services/groups.service";
import { ConnectionService } from "../../../shared/services/connections.service";
import { ReportViewModel } from "../../../shared/classes/ReportViewModel";
import { Connection } from '../../../shared/classes/Connection';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-gerenciar-relatorios',
  templateUrl: './gerenciar-relatorios.component.html',
  styleUrls: ['./gerenciar-relatorios.component.css'],
  providers: [GroupsService, ConnectionService]
  
})
export class GerenciarRelatoriosComponent implements OnInit, OnDestroy  {
  
  id: number;
  reportId: string;
  reportTitle: string;
  reportQuery: string;
  createdBy: string;
  createdOn: Date;
  filtrosQuery: FiltroModel[] = [];
  listaConnections: Connection[];
  connetionId: number;
  resultadoConsulta: RetornoConsultaModel;    
  queryValidated: boolean;
  msgAviso: string;
  msgModalFiltro: string;
  ehEdicao = false;
  class_fa_icon_ok = "fa fa-thumbs-o-up fa-3x text-success";
  class_fa_icon_nok = "fa fa-thumbs-o-down fa-3x text-error";
  class_icon_msg: string;
  maxTamanhoConsulta = 50;
  mostrarCarregando = false;
  listaGrupos: GroupModel[] = [];
  titulo = "Novo Relatório";
  temTop = false;
  msgTemTop = "A presença do 'Top' na query ignora o tamanho máximo do resultado da consulta, podendo ocasionar longo tempo de resposta a depender do valor passado para o 'Top'."
  loggedout = 1;
  isFirefox : boolean = false;
  changeDatePicker: boolean = false;
  

  constructor(private router: Router, 
    private route: ActivatedRoute,
    private _reportsService: ReportsService, 
    private adalService: Adal4Service, 
    private groupsService: GroupsService,
    private connectionService: ConnectionService) {

  }

  ngOnInit() {   

    this.reportId = this.getParameterByName("rid", null);
    console.log("REPORT ID FROM PARAM:", this.reportId);
      // Firefox 1.0+
    this.isFirefox = navigator.userAgent.indexOf("Firefox") >= 0;
    if (this.isFirefox){
      let ua = navigator.userAgent;
      let versaoFirefox = ua.substr(ua.length - 3);

      if(Number(versaoFirefox) < 58){
        this.changeDatePicker = true;
      }
    }

    if(this.reportId){
      this.ehEdicao = true;
      this.initializeSelectedReportViaService(this.reportId);
    }
    //var ehEdicao = this.initializeSelectedReport(); 
    
    if(!this.ehEdicao){//} || localStorage.getItem("editReport") != null){
      // console.log("Não é edição");
      // let editReport = localStorage.getItem("editReport");
      // console.log("editReport (localStorage)", editReport);
      
      // if (editReport != null){
      //   let reportFromStorage = JSON.parse(editReport);
      //   this.setCurrentReportFields(reportFromStorage);
        
      // }
      this.loadGroups();
      this.loadConnections();     
    }else{
      console.log("É edição");
      localStorage.removeItem("editReport")
    }     
  }

  

  ngOnDestroy(){
    this.resetSelectedReport();
    this.ehEdicao = false;
  }

  saveReport(): void {
    if(!this.reportTitle){
      this.msgAviso = "Insira o nome do relatório.";
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();  
      return;
    }
    if(!this.reportQuery){
      this.msgAviso = "Você apagou a query.";
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();  
      return;
    }
    if(this.getSelectGroups().length == 0){
      this.msgAviso = "Você precisa definir pelo menos um grupo de acesso para o relatório.";
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();  
      return;
    }
    if(this.reportId){      
      console.log("SAVE REPORT - É EDIÇÃO")
      this.editReport(Number(this.reportId), this.createReport());
      this.ehEdicao = false;
    }else{
      this.addReport();
    }
    this.titulo = "Novo Relatório";
    this.temTop = false;
  }

  addReport(){    
    var report = this.createReport();
    report.createdOn = new Date();
    var reportVm = new ReportViewModel();

    reportVm.report = report;
    console.log(" reportVm.report:", reportVm.report);
    reportVm.groupsNames = this.getSelectGroups();
    
    this._reportsService.addReport(reportVm).then(report => {
      this.msgAviso = `Relatório criado com sucesso: ${report.reportTitle}`;
      this.class_icon_msg = this.class_fa_icon_ok;
      this.resetCurrentReport();
      document.getElementById("showMensagensModal").click();      
    },erro => {
      this.msgAviso = <any>erro;
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();
    });
  }

  
  validateQueryText() : void{
    if(!this.reportQuery){
        this.msgAviso = "Você não escreveu / colou uma query."
        this.class_icon_msg = this.class_fa_icon_nok;
        document.getElementById("showMensagensModal").click();
        return;
    }
    if (this.filtrosQuery.length > 0){
      var todosFiltrosPreenchidos = true;
      this.filtrosQuery.forEach(filtro => {
        if (!filtro.filterName || !filtro.filterType){
          todosFiltrosPreenchidos = false;         
        }
      });

      if (!todosFiltrosPreenchidos){
         this.msgAviso = "Verifique se todos os filtros estão preenchidos corretamente."
         this.class_icon_msg = this.class_fa_icon_nok;
         document.getElementById("showMensagensModal").click();
         return;
      }

      if(!this.ehEdicao && (!this.connetionId || this.connetionId == 0)){
        this.msgAviso = "Você deve selecionar a conexão.";
        this.class_icon_msg = this.class_fa_icon_nok;
        document.getElementById("showMensagensModal").click();
        return;
      }

      document.getElementById("showFiltrosModal").click();
    }else{
      this.executarSQL();
    }   
  }

  executarSQL(){
    let dadosValidacao = new ValidacaoDadosModel();
    dadosValidacao.queryText = this.reportQuery;
    dadosValidacao.reportFilters = this.filtrosQuery;
    dadosValidacao.pageSize = this.maxTamanhoConsulta; 
    //console.log("connectionId",this.connetionId)   
    dadosValidacao.connectionId = this.connetionId;
    if(dadosValidacao.reportFilters){
      var canProcede = true;
      dadosValidacao.reportFilters.forEach(filtro => {
        if (filtro.isRequired && !filtro.filterValue){          
          canProcede = false;
        }
        // else{
        //   if(this.isFirefox && filtro.filterValue.indexOf("/") > -1){
        //     let arrayData = filtro.filterValue.split('/');
        //     if(arrayData.length != 3){
        //       canProcede = false;
        //     }
        //     let novaData = `${arrayData[2]}-${arrayData[1]}-${arrayData[0]}`;
        //     filtro.filterValue = novaData;
        //   }
        // }
      });
      if(!canProcede){        
        this.msgModalFiltro = "Favor preencher todos os filtros obrigatórios.";
        setTimeout(() => {
          this.msgModalFiltro = null;
        }, 5000);
        return;
      }
      document.getElementById("dismissModalFiltros").click();
    }

    if(this.connetionId == null || this.connetionId == 0){
      this.msgAviso = "Você precisa selecionar uma conexão.";
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();
      return;
    }
    if(this.validarSQL(this.reportQuery)){
      this.mostrarCarregando = true;
      this._reportsService.testarQuery(dadosValidacao).then(reportData => 
      {
        if (reportData == null) return;
        this.resultadoConsulta = reportData; 
        this.printDadosConsulta();
        this.queryValidated = true;      
        this.mostrarCarregando = false;  
        this.msgModalFiltro = null;
      }, error => {
        console.log("error", error);
        this.mostrarCarregando = false; 
        this.msgAviso = error.text();
        this.class_icon_msg = this.class_fa_icon_nok;
        document.getElementById("showMensagensModal").click();
      });
    }    
  }

  addSlash(valorFiltro){
    
    //if(valorFiltro.length == 2){
      console.log(valorFiltro.length);
    //}
  }

  validarSQL(sql: string): boolean{
    if ((sql.toLowerCase().indexOf("select") == -1 || sql.toLowerCase().indexOf("from") == -1)
    || (sql.indexOf("{{") > -1 && sql.indexOf("}}") == -1)
    || (sql.indexOf("}}") > -1 && sql.indexOf("{{") == -1)){
      this.msgAviso = "Query inválida!"
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();
      return false;
    }
    if(sql.indexOf("@") > -1 && this.filtrosQuery.length == 0){
      this.msgAviso = "A query está parametrizada mas nenhum filtro foi adicionado."
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();
      return false;
    }

    return true;
  }

  printDadosConsulta() : void{
    console.log(this.resultadoConsulta);
  }

  addFilterLine() {
    let filter = new FiltroModel();
    filter.isRequired = true;
    this.filtrosQuery.push(filter);    
  }

  removeFiltro(i: number) {
    this.filtrosQuery.splice(i, 1);
    if(this.reportQuery){
      this.queryValidated = false;
    }
    console.log("filtros query depois de excluido: ", this.filtrosQuery);
  }

  resetCurrentReport(){
    this.reportQuery = null;
    this.reportTitle = null;
    this.filtrosQuery = [];
    this.resultadoConsulta = null;
    this.listaGrupos.forEach(grupo => {
      grupo.selected = false;
    });
  }

  initializeSelectedReportViaService(reportId: string){
    return this._reportsService.getReportById(Number(reportId))
    .then(report => {
      console.log("Report from service: ",report);
      this.setCurrentReportFields(report);
      this.connectionService.getConnectionById(report.connectionId).then(conn => {
        //console.log("conn:", conn);
        this.listaConnections = new Array<Connection>();
        this.listaConnections.push(conn);
        
        this.connetionId = this.listaConnections[0].id;
      });

      this.setGroupsReport(report);  
    }).catch(erro =>{
      this.msgAviso = <any>erro;
      if(erro.status == 403 || erro.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal2").click()
    })
  }  

  initializeSelectedReport(){
    var selectedReport = this._reportsService.getSelectedReport();
    if(selectedReport){
      localStorage.setItem("editReport", JSON.stringify(selectedReport));
      this.setCurrentReportFields(selectedReport);
      console.log("selectedReport.connectionId", selectedReport.connectionId);
      this.connectionService.getConnectionById(selectedReport.connectionId).then(conn => {
        //console.log("conn:", conn);
        this.listaConnections = new Array<Connection>();
        this.listaConnections.push(conn);
        
        this.connetionId = this.listaConnections[0].id;
      });

      this.setGroupsReport(selectedReport);         
      return true;  
    }
    return false;
  }
  
  setGroupsReport(selectedReport: ReportModel){
    var rolesGrupoRelatorio = selectedReport.accessGroups.map((g) => g.roleName);
    console.log('rolesGrupoRelatorio', rolesGrupoRelatorio);
    
    this.loadGroups().then(() => {       
      this.listaGrupos.forEach(grupo => {      
        if(rolesGrupoRelatorio.some((roleName) => roleName == grupo.value)){
          grupo.selected = true;             
        }
      }); 
    });
  }

  setCurrentReportFields(selectedReport: ReportModel){
      this.ehEdicao = true;
      this.titulo = "Editar Relatório";
      this.reportTitle = selectedReport.reportTitle;
      this.reportQuery = selectedReport.reportQuery;
      this.filtrosQuery = selectedReport.reportFilters;
      this.connetionId = selectedReport.connectionId;
      this.id = selectedReport.id;
      //this.setGroupsReport(selectedReport);
  }

  editReport(id: number, report: ReportModel){
    console.log("id", id);
    console.log("report", report);
    var reportVm = new ReportViewModel();
    reportVm.report = report;
    reportVm.groupsNames = this.getSelectGroups();
    this._reportsService.updateReport(id, reportVm).then(() => {
      this.msgAviso = "Relatório atualizado com sucesso!";
      //this.resetCurrentReport();
      this.class_icon_msg = this.class_fa_icon_ok;
      document.getElementById("showMensagensModal").click();
    }, erro => {
      this.msgAviso = `Ocorreu um erro ao tentar atualizar o relatório: ${<any>erro}`
      if(erro.status == 403 || erro.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();
    })
  }

  resetSelectedReport(){
    this._reportsService.setSelectedReport(null);
    this.reportTitle = null;
    this.reportQuery = null;
    this.filtrosQuery = [];
  }

  createReport() : ReportModel{
    let report = new ReportModel();
    report.reportTitle = this.reportTitle;
    report.reportQuery = this.reportQuery;
    report.connectionId = this.connetionId;
    report.hasFilters = false;
    if(this.filtrosQuery.length > 0){
      report.reportFilters = this.filtrosQuery; 
      // report.reportFilters.forEach(filtro => {
      //   filtro.filterValue = "";
      // });
      report.hasFilters = true;
    }   
    return report;
  }
  
  getSelectGroups() : string[]{
    console.log("dentro do getSelectedGroups()");
    console.log("this.listaGrupos", this.listaGrupos);
    var nomesGruposSelecionados = this.listaGrupos.filter((g) => g.selected).map((gr) => gr.value);    
    return nomesGruposSelecionados;        
  }

  loadGroups() : Promise<any>{    
    
    return this.groupsService.getGroups().then(grupos =>{ 
        grupos.forEach(grupo => {
        if(grupo.displayName.toLowerCase().indexOf("consulta") > -1){
          grupo.displayName = grupo.displayName.split(" ")[1];
        }
      });
      this.listaGrupos = grupos;
      console.log("listagroups depois do serviço", this.listaGrupos);
    }).catch(erro => {
      this.msgAviso = erro.text() || <any>erro;
      if(erro.status == 403 || erro.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();
    });
  }

  loadConnections() {
    this.connectionService.getConnections().then(connections =>{      
      this.listaConnections = connections;
      if(this.listaConnections.length == 1){
        this.connetionId = this.listaConnections[0].id;
      }
      console.log("listaConnections depois do serviço", this.listaConnections);
    }).catch(erro => {
      this.msgAviso = erro.text() || <any>erro;
      if(erro.status == 403 || erro.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal").click();
    });
  }

  alertAboutTop(){
    if(this.reportQuery.toUpperCase().indexOf("SELECT TOP") > 1){
      this.temTop = true;
    }
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/relatorios/gerenciar-relatorios/gerenciar-relatorios.component.ts